import { type FilterValues } from "components/filters/FilterContext";
import { mapClientFilterToInstruction, mapEnvironmentFilterToInstruction, mapHubSpotFilterToInstruction, mapKeywordFilterToInstruction, mapResponseToClientFilter, mapResponseToEnvironmentsFilter, mapResponseToHubSpotFilter, mapResponseToKeywordFilter, mapResponseToUserToClientLifecycleFilter, mapUserToClientLifecycleToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedUserForAdminOneInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    clientIds: mapClientFilterToInstruction(filter.client),
    environments: mapEnvironmentFilterToInstruction(filter.environment),
    userToClientLifeCycles: mapUserToClientLifecycleToInstruction(filter.userToClientLifecycle),
    linkedToHubSpot: mapHubSpotFilterToInstruction(filter.hubSpotLinked),
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListUserForAdminOneFilters
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response?.keyword),
  client: mapResponseToClientFilter(response?.clients),
  environment: mapResponseToEnvironmentsFilter(response?.environments),
  userToClientLifecycle: mapResponseToUserToClientLifecycleFilter(response?.userToClientLifeCycles),
  hubSpotLinked: mapResponseToHubSpotFilter(response?.linkedToHubSpot)
});